import { EditOutlined } from '@ant-design/icons'
import { MultipleChoiceGroup } from '@ulysses-inc/harami_api_client'
import { Button } from 'antd'
import React from 'react'

type MultipleChoiceEditButtonProps = {
  multipleChoiceGroup: MultipleChoiceGroup
  openMultipleChoiceDrawer: (group: MultipleChoiceGroup) => void
}

export const MultipleChoiceEditButton: React.FC<
  MultipleChoiceEditButtonProps
> = ({ multipleChoiceGroup, openMultipleChoiceDrawer }) => {
  return (
    <Button
      onMouseDown={() => {
        openMultipleChoiceDrawer(multipleChoiceGroup)
      }}
      type="link"
      icon={<EditOutlined />}
    />
  )
}
